import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessRoute extends Route {
  @service router;

  beforeModel() {
    this.router.on('routeDidChange', this.redirectToInnerPage);
    this.router.on('routeWillChange', this.blockInnerToParentPage);
  }

  redirectToInnerPage = (transition) => {
    if (transition?.to?.name === 'business.index')
      this.router.transitionTo('business.goals.list');
  };

  blockInnerToParentPage = (transition) => {
    if (
      transition?.to?.name === 'business.index' &&
      ['business.goals', 'business.goals.list', 'business.financials'].includes(
        transition?.from?.name,
      )
    )
      transition.abort();
  };

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.router.off('routeDidChange', this.redirectToInnerPage);
      this.router.off('routeWillChange', this.blockInnerToParentPage);
    }
  }
}

export default instrumentRoutePerformance(BusinessRoute);
